export const categories = [
  'À Vista',
  'Pontual',
  '8 à 15',
  '16 à 30',
  '31 à 60',
  'Acima 60',
]
export const profileProperties = [
  'avista',
  'pontual',
  'de8a15',
  'de16a30',
  'de31a60',
  'acima60',
]

export const colors = [
  'rgba(0, 102, 204, 0.7)',
  'rgba(76, 177, 64, 0.7)',
  'rgba(87, 82, 209, 0.7)',
  'rgba(244, 193, 69, 0.7)',
  'rgba(236, 122, 8, 0.7)',
  'rgba(201, 25, 11, 0.7)',
  'rgba(255, 159, 64, 0.7)',
  'rgba(0, 166, 147, 0.7)',
  'rgba(153, 102, 255, 0.7)',
]

export const borders = [
  'rgb(0, 102, 204)',
  'rgb(76, 177, 64)',
  'rgb(87, 82, 209)',
  'rgb(244, 193, 69)',
  'rgb(236, 122, 8)',
  'rgb(201, 25, 11)',
  'rgb(255, 159, 64)',
  'rgb(0, 166, 147)',
  'rgb(153, 102, 255)',
]
